<template>
  <div>
    <div class="grid grid-cols-2 gap-6">
      <div>
        <TButtonSvg label="Select All" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <polyline points="9 11 12 14 20 6" />
            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Take mass quick actions on more than one record at once using the Select All button. Great for getting things
          done quickly!
        </p>
      </div>
      <div>
        <TButtonSvg label="Mark as Read" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
            <line x1="9" y1="7" x2="10" y2="7" />
            <line x1="9" y1="13" x2="15" y2="13" />
            <line x1="13" y1="17" x2="15" y2="17" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">Quickly mark any selected conversation as read.</p>
      </div>
      <div>
        <TButtonSvg label="Export" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <line x1="17" y1="7" x2="7" y2="17" />
            <polyline points="8 7 17 7 17 16" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Exports all of your inbox messages as a CSV file great for analysis in other systems or for importing into
          other systems.
        </p>
      </div>
    </div>
  </div>
</template>
